import VideoCard from './video-card';

export default class VideoCardDesktop extends VideoCard {
    constructor(...args) {
        super(...args);
    }

    init() {
        super.init();
        this.dom.btn = this.dom.component.querySelector('.js-open-video');
        this.dom.btnClose = this.dom.popin.querySelector('.js-close-video');

    }

    bind() {
        this.dom.component.classList.add('is-binded');
        this.dom.btn.addEventListener('click', this._openPopinVideo.bind(this));
        this.dom.btnClose.addEventListener('click', this._closePopinVideo.bind(this));
    }

    _openPopinVideo(){

        let url = this.dom.btn.getAttribute('data-video-url');

        this.dom.video.setAttribute('src', url);
        this.dom.video.setAttribute('autoplay', 'true');

        TweenLite.to(this.dom.popin, 0.4, {
            autoAlpha: 1,
            ease: Power3.easeOut,
            onComplete: () => {
                document.body.classList.add('no-scroll');
            }
        });

    }

    _closePopinVideo(){

        this.dom.video.pause();

        TweenLite.to(this.dom.popin, 0.4, {
            autoAlpha: 0,
            ease: Power3.easeOut,
            onComplete: () => {
                document.body.classList.remove('no-scroll');
            }
        });
    }
    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/video-card/video-card.desktop.js